import { render, staticRenderFns } from "./EndpointMetric.vue?vue&type=template&id=b4fc0da4"
import script from "./EndpointMetric.vue?vue&type=script&lang=js"
export * from "./EndpointMetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports